<template>
  <div class="order-type" v-if="!selfDestruct && shouldShowModal">
    <modal
      full-header
      :hide-footer="!showNextBtn"
      width="600px"
      :can-be-dismissed="false"
      ref="orderTypeModal"
      :full-screen="isMobile()"
      :borderless="isMobile()"
    >
      <template slot="header">
        <div class="order-type-header" v-if="!isMobile()">
          <img
            v-if="showBackButton"
            src="@/assets/back-arrow.png"
            class="icon-back-arrow"
            @click="backButtonPressed"
          />
          <h3>{{ headerTitle }}</h3>
        </div>
        <div class="fixed-banner" v-if="isMobile()">
          <div class="container-fluid banner-alt">
            <div class="row">
              <div class="col-8 banner-title align-items-center">
                <span v-show="showNextBtn" class="material-icons md-36">
                  <img
                    src="@/assets/back-arrow.png"
                    class="icon-back-arrow"
                    @click="backButtonPressed"
                  />
                </span>
                <h3 class="mt-2" v-show="showNextBtn">{{ headerTitle }}</h3>
              </div>
              <ul class="nav account-btns banner-locale">
                <li class="dropdown">
                  <a
                    id="navbarDropdown"
                    class="dropdown-toggle"
                    href="#"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span>
                      <i class="fa fa-globe" style="font-size: 16pt"></i>
                    </span>
                  </a>
                  <div
                    class="dropdown-menu lg-dropdown-menu home-page-dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <a
                      v-for="(lang, index) in getAvailableLanguages"
                      :key="index"
                      href="javascript:void(0)"
                      class="dropdown-item pl-0"
                      @click="setLocale(lang.locale)"
                      >{{ lang.name }}</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- fixed-banner-double -->
        <div style="height:70px" v-if="isMobile()"></div>
      </template>
      <template slot="body">
        <div v-if="!showNextBtn" class="home-page-container">
          <div class="home-page-logo">
            <img :src="getLogo" />
          </div>
          <h3 :style="splashTextStyles">{{ selectedCompany.Name }}</h3>

          <div :style="splashTextStyles">
            <h6 v-if="opening && (opening.openTime || opening.closeTime)">
              {{ $t("message.open") }}
              <span>{{ opening.openTime }}</span>
              {{ $t("message.toName") }}
              <span>{{ opening.closeTime }}</span>
            </h6>
            <h6 v-else-if="!isEnablePreOrder">
              {{ $t("message.closedToday") }}
            </h6>
          </div>
          <div
            class="home-page-store-status"
            v-if="!storeClosed || !isEnablePreOrder"
          >
            <span :class="storeClosed ? 'offline' : 'online'"></span>
            <p v-if="storeClosed">{{ $t("message.storeOffline") }}</p>
            <p v-else>{{ $t("message.storeOnline") }}</p>
          </div>
        </div>
        <choose-order-type
          v-if="step === 1"
          :show-delivery="storeSupportsDelivery(selectedCompany)"
          :show-dinein="storeSupportsDinein(selectedCompany)"
          :show-pickup="storeSupportsPickup(selectedCompany)"
          :chosen-index="orderTypeIndex"
          @order-type-changed="setOrderType"
        ></choose-order-type>
        <div v-if="step === 1 && isMobile()" style="margin-top:-1rem">
          <poweredby />
        </div>
        <enter-delivery-address
          v-if="showEnterAddress"
          :store-supports-pickup="storeSupportsPickup(selectedCompany)"
          @pickup-instead="pickUpInstead"
          @set-delivery-address="setDeliveryAddress"
          @delivery-address-enable="enableDeliveryAddress"
        ></enter-delivery-address>
        <enter-delivery-time
          v-if="showEnterTime"
          @set-scheduled-time="setScheduledTime"
        ></enter-delivery-time>
      </template>
      <template slot="footer">
        <div class="order-type-footer">
          <button
            type="button"
            :disabled="disableNextButton"
            :style="desktopStyles.btn"
            :class="{ disabled: disableNextButton }"
            class="btn btn-primary btn-lg btn-block d-flex justify-content-center align-items-center"
            @click="nextButtonClickHandler()"
          >
            <span>
              {{ step === 3 ? $t("message.confirm") : $t("message.next") }}
            </span>
            <span v-show="getDeliveryIsLoading && disableNextButton">
              <i class="spin ml-4" />
            </span>
          </button>
        </div>
        <poweredby v-if="isMobile()" />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import modal from "../modal";
import ChooseOrderType from "./ordertype/ChooseOrderType.vue";
import EnterDeliveryAddress from "./ordertype/EnterDeliveryAddress";
import EnterDeliveryTime from "./ordertype/EnterDeliveryTime";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_PICKUP,
  CONSTANT_ORDER_TYPE_DINEIN,
  CONSTANT_DELIVERY_ADDRESS,
  CONSTANT_DELIVERY_TIME,
} from "../../constans/strings";
import { orderTypeHelper } from "../../api/helpers/orderTypeHelper";
import {
  getCurrentDate,
  IsStoreOpenAtTime,
  operatingHours,
} from "../../api/helpers/datetimeHelper";
import { orderTypeSelectionEnabled } from "../../api/helpers/orderHelper";
import poweredby from "../shared/poweredby.vue";
import { Validator } from "vee-validate";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
export default {
  name: "OrderType",
  components: {
    modal,
    ChooseOrderType,
    EnterDeliveryAddress,
    EnterDeliveryTime,
    poweredby,
  },
  data() {
    return {
      step: 1,
      orderTypeIndex: 0,
      showOrderType: true,
      deliveryLocation: null,
      deliveryAddressEnable: true,
      scheduledTime: null,
      selfDestruct: false,
    };
  },
  mounted() {
    const hasOrderType = orderTypeHelper.getOrderType();
    const skipFirstStep = orderTypeHelper.getSkipFirstStep();

    if (!hasOrderType) {
      if (this.storeSupportsDelivery(this.selectedCompany)) {
        this.orderTypeIndex = 0;
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
        this.setIsDelivery(true);
      } else if (this.storeSupportsPickup(this.selectedCompany)) {
        this.orderTypeIndex = 2;
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
        this.setIsDelivery(false);
      } else if (this.storeSupportsDinein(this.selectedCompany)) {
        this.orderTypeIndex = 1;
        this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
        this.setIsDelivery(false);
      } else {
        this.showOrderType = false;
      }
    } else if (hasOrderType && !skipFirstStep) {
      this.hideModal();
    } else if(hasOrderType && skipFirstStep) {
      if(hasOrderType == CONSTANT_ORDER_TYPE_DELIVERY) {
        this.orderTypeIndex = 0;
        this.setIsDelivery(true);
      } else if(hasOrderType == CONSTANT_ORDER_TYPE_PICKUP) {
        this.orderTypeIndex = 2;
        this.setIsDelivery(false);
      } else {
        this.orderTypeIndex = 1;
        this.setIsDelivery(false);
      }

      if(!this.isMobile()) {
        this.nextButtonClickHandler();
      }
    }
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      "mobileStyles",
      "selectedCompany",
      "hqDoc",
      "currentStoreDoc",
      "getDeliveryIsLoading",
      "getAvailableLanguages",
    ]),
    shouldShowModal() {
      return orderTypeSelectionEnabled(this.currentStoreDoc, this.currentStoreDoc.ViewComponentConfigs);
    },
    showBackButton() {
      return this.step > 1;
    },
    showEnterAddress() {
      return this.step === 2 && this.orderTypeIndex === 0;
    },
    showEnterTime() {
      return (
        this.step === 3 &&
        (this.orderTypeIndex === 0 || this.orderTypeIndex === 2)
      );
    },
    disableNextButton() {
      return (
        this.step === 2 &&
        (!this.deliveryLocation ||
          !this.deliveryAddressEnable ||
          this.getDeliveryIsLoading)
      );
    },
    headerTitle() {
      return this.step === 1
        ? this.$t("message.chooseAOrderType")
        : this.step === 2
        ? this.$t("message.deliveryDetails")
        : orderTypeHelper.isDelivery()
        ? this.$t("message.deliveryDetails")
        : this.$t("message.pickUpDetails");
    },
    getLogo() {
        return this.selectedCompany.Logo;
    },
    opening() {
      if (this.selectedCompany.OperatingHours) {
        var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
        return operatingHours(this.selectedCompany.BlackoutDates, now, this.selectedCompany.OperatingHours);
      } else {
        return null;
      }
    },
    isEnablePreOrder() {
      return (
        this.selectedCompany.IsInOperation &&
        (this.selectedCompany.EnablePreoderForDelivery ||
          this.selectedCompany.EnablePreoderForPickup)
      );
    },
    storeClosed() {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      return !IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
    },
    showNextBtn() {
      return !this.isMobile() || this.showBackButton;
    },
    splashTextStyles() {
      return this.mobileStyles.splashScreenTextColor;
    },
  },
  methods: {
    ...mapMutations(["setIsDelivery"]),
    ...mapMutations(["setSelectedMenuType", "setCurrentLocale"]),
    storeSupportsDelivery: orderTypeHelper.storeSupportsDelivery,
    storeSupportsDinein: orderTypeHelper.storeSupportsDinein,
    storeSupportsPickup: orderTypeHelper.storeSupportsPickup,
    nextButtonClickHandler() {
      if (this.step === 1) {
        const value =
          this.orderTypeIndex === 0
            ? CONSTANT_ORDER_TYPE_DELIVERY
            : this.orderTypeIndex === 1
            ? CONSTANT_ORDER_TYPE_DINEIN
            : CONSTANT_ORDER_TYPE_PICKUP;

        orderTypeHelper.setOrderType(value);
        if (this.orderTypeIndex == 1) {
          this.hideModal();
        } else if (this.orderTypeIndex === 2) {
          this.step++;
        }
      } else if (this.step === 2) {
        sessionStorage.setItem(
          CONSTANT_DELIVERY_ADDRESS,
          JSON.stringify(this.deliveryLocation)
        );
      } else if (this.step === 3) {
        sessionStorage.setItem(CONSTANT_DELIVERY_TIME, this.scheduledTime);
        this.hideModal();
      } else {
        this.hideModal();
      }

      this.step++;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      Validator.localize(locale, locale == "en" ? en : zh_CN);
      this.setCurrentLocale(locale);
    },
    setOrderType(index) {
      this.orderTypeIndex = index;
      switch (index) {
        case 0:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
          this.setIsDelivery(true);
          break;
        case 1:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
          this.setIsDelivery(false);
          break;
        case 2:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
          this.setIsDelivery(false);
          break;
      }
      if (this.isMobile()) {
        this.nextButtonClickHandler();
      }
    },
    setDeliveryAddress(location) {
      this.deliveryLocation = location;
    },
    enableDeliveryAddress(value) {
      this.deliveryAddressEnable = !value;
    },
    setScheduledTime(time) {
      this.scheduledTime = time;
    },
    backButtonPressed() {
      if (this.step === 2) {
        orderTypeHelper.removeOrderType();
        this.step = 1;
      } else if (this.step === 3 && this.orderTypeIndex === 2) {
        orderTypeHelper.removeDeliveryAddress();
        orderTypeHelper.removeOrderType();
        this.step = 1;
      } else if (this.step === 3) {
        orderTypeHelper.removeDeliveryAddress();
        this.step = 2;
      }
    },
    hideModal() {
      this.selfDestruct = true;
      if (this.$refs.orderTypeModal) {
        this.$refs.orderTypeModal.hideModal(true);
        setTimeout(() => {
          if (this.$refs.orderTypeModal)
            this.$refs.orderTypeModal.hideModal(true);
        }, 500);
      }
    },
    pickUpInstead() {
      this.setOrderType(2);
      this.nextButtonClickHandler();
    },
  },
};
</script>
